/**
 * @file components/appUsers/users.js
 */

import React from "react";
import { connect } from "react-redux";
import { Link, withRouter, useHistory } from "react-router-dom";
import { utils } from "../../utils/utils_general";
import { Form, Button, Alert } from "react-bootstrap";
import { UNEXPECTED_ERROR, RESPONSE_CODE } from "../../constants/errors";
import { PAGES } from "../../constants/pages";
import UserList from "./users_list";
import {
  post_app_user_list,
  bulk_hard_delete_app_users,
} from "../../actions/appUserAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faEnvelope,
  faTrash,
  faLock,
  faRunning,
} from "@fortawesome/free-solid-svg-icons";
import { dash_kpi } from "../../actions/reportAction";
import BulkHardDeleteModal from "../modals/bulk-hard-delete-modal";

class AppUsers extends React.Component {
  constructor() {
    super();
    this.state = {
      errors: {},
      users: null,
      currentPage: 1,
      prevPage: null,
      totalPages: 1,
      totalUsers: null,
      paginationSize: 50,
      searchString: null,
      searchStatus: "",
      sortOrder: 1,
      sortColumn: "first_name",
      activeUsers: null,
      pendingUsers: null,
      harddeleteUsers: null,
      kbaNotVerified: null,
      lockoutUsers: null,
      bulkDelete: {
        showModal: false,
        isDeleting: false,
        error: null,
        result: null,
        requests: [],
        isLoadingList: false,
        listError: null,
      },
    };
  }

  componentDidMount() {
    if (this.props.location.state) {
      this.setState({
        currentPage: this.props.location.state.pageNum
          ? this.props.location.state.pageNum
          : this.state.currentPage,
      });
      this.postUsers(this.props.location.state.pageNum);
    } else {
      this.postUsers(this.state.currentPage);
    }

    this.renderKPI();
  }

  postUsers(pageNum, sortColmun, sortOrder) {
    const searchString = utils.get_url_param(
      this.props.location.search,
      "Search",
    );
    const effectiveSearch =
      this.state.searchString !== null
        ? this.state.searchString
        : searchString;

    const data = {
      page_num: pageNum,
      page_size: this.state.paginationSize,
      email: effectiveSearch || null,
      status: this.state.searchStatus || null,
      sort_item: this.state.sortColumn,
      sort_asc: this.state.sortOrder,
    };

    return this.props
      .post_app_user_list(data)
      .then((response) => {
        const currentPage = data.page_num;
        var records = response.length;

        console.log("RECORDS", records);

        if (!records) {
          this.handlerError("Did not find any record");
          this.setState({
            currentPage,
            nextPage: 0,
            prevPage: 0,
            users: [],
          });
          return;
        }
        var n, p;

        if (records >= 50) {
          if (data.page_num === 1) {
            n = data.page_num + 1;
            p = 0;
          } else {
            n = data.page_num + 1;
            p = data.page_num - 1;
          }
        } else {
          n = 0;
          p = data.page_num - 1;
        }

        const nextPage = n;
        const prevPage = p;

        this.setState({
          currentPage,
          nextPage,
          prevPage,
          users: response,
          errors: {},
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === RESPONSE_CODE["401_unauthorized"]) {
            this.props.history.push(PAGES.LOGIN);
          } else if (
            error.response.status === RESPONSE_CODE["405_data_invalid"]
          ) {
            this.handlerError("Invalid data. Error in response.");
          }
        } else {
          this.handlerError(UNEXPECTED_ERROR);
        }
      });
  }

  reloadUsers(column) {
    if (column !== this.state.sortColumn) {
      this.setState({ sortOrder: 1 });
    } else {
      this.setState({ sortOrder: this.state.sortOrder === 1 ? 0 : 1 });
    }
    this.setState({ sortColumn: column }, () => {
      this.postUsers(1);
    });
  }

  renderKPI() {
    return this.props
      .dash_kpi()
      .then((response) => {
        console.log(response);
        this.processData(response);
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === RESPONSE_CODE["401_unauthorized"]) {
            this.props.history.push(PAGES.LOGIN);
          }
        } else {
          this.handlerError(UNEXPECTED_ERROR);
        }
      });
  }

  processData(response) {
    this.setState({ totalUsers: response.total_app_users.total_users });

    if (response.app_users) {
      this.setState({ activeUsers: this.validKey(response, "active") });
      this.setState({ lockoutUsers: this.validKey(response, "lockout") });
      this.setState({ pendingUsers: this.validKey(response, "pending") });
      this.setState({
        harddeleteUsers: this.validKey(response, "hard_delete_request"),
      });
      this.setState({
        kbaNotVerified: this.validKey(response, "kba_not_verified"),
      });
    }
  }

  validKey(response, key) {
    const val = response.app_users.find((q) => q.status === key);
    let count_val;

    if (val) count_val = val.count;
    else count_val = 0;

    return count_val;
  }

  handlerError(error) {
    this.setState({ errors: { system: error } });
  }

  openBulkDeleteModal() {
    this.setState(
      {
        bulkDelete: {
          ...this.state.bulkDelete,
          showModal: true,
          error: null,
          listError: null,
          isLoadingList: true,
        },
      },
      () => {
        this.fetchHardDeleteRequests();
      },
    );
  }

  closeBulkDeleteModal() {
    this.setState({
      bulkDelete: {
        ...this.state.bulkDelete,
        showModal: false,
        error: null,
        requests: [],
      },
    });
  }

  async fetchHardDeleteRequests() {
    const pageSize = 200;
    let page = 1;
    const collected = [];

    try {
      while (true) {
        const response = await this.props.post_app_user_list({
          page_num: page,
          page_size: pageSize,
          status: "hard_delete_request",
          sort_item: "email",
          sort_asc: 1,
        });

        const batch = Array.isArray(response)
          ? response.filter((u) => u.status === "hard_delete_request")
          : [];

        collected.push(...batch);

        if (!response || response.length < pageSize) {
          break;
        }
        page += 1;
      }

      this.setState({
        bulkDelete: {
          ...this.state.bulkDelete,
          requests: collected,
          isLoadingList: false,
          listError: null,
        },
      });
    } catch (error) {
      this.handleHardDeleteLoadError(error);
    }
  }

  handleHardDeleteLoadError(error) {
    if (error.response) {
      if (error.response.status === RESPONSE_CODE["401_unauthorized"]) {
        this.props.history.push(PAGES.LOGIN);
        return;
      }
    }
    const status =
      error && error.response ? ` (status ${error.response.status})` : "";
    this.setState({
      bulkDelete: {
        ...this.state.bulkDelete,
        listError: `Unable to load hard delete requests${status}.`,
        isLoadingList: false,
      },
    });
  }

  buildDeleteResultMessage(response) {
    const deleted = response.deleted || [];
    const failed = response.failed || [];
    const failedDetails = failed
      .map((f) => (f.error ? `${f.app_user_id} (${f.error})` : f.app_user_id))
      .join(", ");

    const message = `Hard delete completed. Deleted: ${deleted.length}${
      failed.length ? `, Failed: ${failed.length}` : ""
    }.${failedDetails ? ` Failed IDs: ${failedDetails}` : ""}`;

    return {
      variant: failed.length ? "warning" : "success",
      message,
    };
  }

  async handleBulkHardDelete() {
    const { currentPage } = this.state;
    const { requests } = this.state.bulkDelete;
    if (!requests || requests.length === 0) {
      this.setState({
        bulkDelete: {
          ...this.state.bulkDelete,
          error: "No users are currently flagged for hard delete.",
        },
      });
      return;
    }

    this.setState({
      bulkDelete: {
        ...this.state.bulkDelete,
        isDeleting: true,
        error: null,
      },
    });

    try {
      const ids = requests.map((u) => u.app_user_id);
      const response = (await this.props.bulk_hard_delete_app_users(ids)) || {};

      this.setState({
        bulkDelete: {
          ...this.state.bulkDelete,
          isDeleting: false,
          showModal: false,
          result: this.buildDeleteResultMessage(response),
          requests: [],
        },
      });

      this.postUsers(currentPage);
      this.renderKPI();
    } catch (error) {
      if (error?.response?.status === RESPONSE_CODE["401_unauthorized"]) {
        this.props.history.push(PAGES.LOGIN);
        this.setState({
          bulkDelete: {
            ...this.state.bulkDelete,
            isDeleting: false,
          },
        });
        return;
      }

      this.setState({
        bulkDelete: {
          ...this.state.bulkDelete,
          error: error?.response
            ? "Unable to complete bulk hard delete."
            : "Unexpected error while hard deleting users.",
          isDeleting: false,
        },
      });
    }
  }

  handleNext(e) {
    this.handlerError("");
    this.postUsers(this.state.nextPage);
  }

  handlePrev(e) {
    this.handlerError("");
    this.postUsers(this.state.prevPage);
  }

  handleSearchChange = (e) => {
    this.setState({ searchString: e.target.value });
  };

  handleStatusChange = (e) => {
    this.setState({ searchStatus: e.target.value }, () => {
      this.postUsers(1);
    });
  };

  handleClear = () => {
    this.setState({ searchString: "", searchStatus: "", errors: {} }, () => {
      this.postUsers(1);
    });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    this.postUsers(1);
  }

  renderSearch() {
    const urlSearch = utils.get_url_param(this.props.location.search, "Search");
    const searchValue =
      this.state.searchString !== null
        ? this.state.searchString
        : urlSearch || "";

    return (
      <div className="row pt-3 mb-4">
        <div className="col-12">
          <Form
            noValidate
            onSubmit={this.handleSearchSubmit}
          >
            <div className="form-row align-items-center justify-content-end">
              <div className="col-auto">
                <Form.Control
                  as="select"
                  value={this.state.searchStatus}
                  onChange={this.handleStatusChange}
                  className="custom-select"
                >
                  <option value="">All</option>
                  <option value="pending">Pending</option>
                  <option value="active">Active</option>
                  <option value="suspend">Suspended</option>
                  <option value="lockout">Lockout</option>
                </Form.Control>
              </div>
              <div className="col-auto">
                <Form.Control
                  name="Search"
                  placeholder="Search by email only"
                  value={searchValue}
                  onChange={this.handleSearchChange}
                />
              </div>
              <div className="col-auto">
                <Button variant="info" type="submit">
                  Search
                </Button>
              </div>
              <div className="col-auto">
                <Button variant="secondary" onClick={this.handleClear}>
                  Clear
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }

  renderPagination() {
    if (!this.state.users) {
      return null;
    }
    return (
      <div className="row p-3">
        <div className="col-12 text-right">
          <div className="p-0">
            {this.state.currentPage > 1
              ? (this.state.currentPage - 1) * this.state.paginationSize + 1
              : 1}
            -
            {this.state.users.length === this.state.paginationSize
              ? this.state.currentPage * this.state.paginationSize
              : (this.state.currentPage - 1) * this.state.paginationSize +
              this.state.users.length}
            <Button
              variant="link"
              onClick={(e) => this.handlePrev(e)}
              className="btn-link nav-arrow p-0"
              disabled={this.state.prevPage ? false : true}
            >
              <i className="arrow left"></i>
            </Button>
            <Button
              variant="link"
              onClick={(e) => this.handleNext(e)}
              className="btn-link nav-arrow p-0"
              disabled={this.state.nextPage ? false : true}
            >
              <i className="arrow right"></i>
            </Button>
          </div>
        </div>
      </div>
    );
  }

  renderUserSummary() {
    if (!this.state.users) {
      return null;
    }
    return (
      <div className="row pt-4">
        <div className="col-xl-2 col-md-2 mb-2">
          <div className="card border-left-success  h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                    Participants{" "}
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-muted">
                    {this.state.totalUsers}
                  </div>
                </div>
                <div className="col-auto  fa-1x  text-gray-300">
                  <FontAwesomeIcon icon={faUsers} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-2 col-md-2 mb-2">
          <div className="card border-left-success  h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                    Active{" "}
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-muted">
                    {this.state.activeUsers}
                  </div>
                </div>
                <div className="col-auto  fa-1x  text-gray-300">
                  <FontAwesomeIcon icon={faRunning} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-2 col-md-2 mb-2">
          <div className="card border-left-success  h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                    Pending{" "}
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-muted">
                    {this.state.pendingUsers}
                  </div>
                </div>
                <div className="col-auto  fa-1x  text-gray-300">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-2 col-md-2 mb-2">
          <div className="card border-left-success  h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                    Lockout{" "}
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-muted">
                    {this.state.lockoutUsers}
                  </div>
                </div>
                <div className="col-auto  fa-1x  text-gray-300">
                  <FontAwesomeIcon icon={faLock} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-2 col-md-2 mb-2">
          <div className="card border-left-info  h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                    KBA Not Verified
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-muted">
                    {this.state.kbaNotVerified}
                  </div>
                </div>
                <div className="col-auto  fa-1x  text-gray-300">
                  <FontAwesomeIcon icon={faUsers} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-2 col-md-2 mb-2">
          <div className="card border-left-danger  h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-danger text-uppercase mb-1">
                    Hard Delete Request
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-muted">
                    {this.state.harddeleteUsers}
                  </div>
                </div>
                <div className="col-auto  fa-1x  text-gray-300">
                  <FontAwesomeIcon icon={faTrash} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <section className="users container">
        <div className="mt-3 mb-3">
          <p className="mb-3 text-muted h3 mb-0 text-gray-800">
            {" "}
            Users &nbsp;&nbsp;
            <button className="btn btn-info">Import Users</button>
            <button
              className="btn btn-danger ml-2"
              disabled={!this.state.harddeleteUsers}
              onClick={() => this.openBulkDeleteModal()}
              style={
                !this.state.harddeleteUsers
                  ? {
                      backgroundColor: "#ccc",
                      borderColor: "#ccc",
                      color: "#888",
                      cursor: "not-allowed",
                    }
                  : {}
              }
            >
              Bulk Hard Delete
            </button>
          </p>
        </div>

        {this.state.bulkDelete.result ? (
          <Alert
            variant={this.state.bulkDelete.result.variant}
            onClose={() =>
              this.setState({
                bulkDelete: {
                  ...this.state.bulkDelete,
                  result: null,
                },
              })
            }
            dismissible
          >
            {this.state.bulkDelete.result.message}
          </Alert>
        ) : null}

        <React.Fragment>{this.renderUserSummary()}</React.Fragment>
        <React.Fragment>{this.renderSearch()}</React.Fragment>
        <UserList
          displayUsers={this.state.users}
          paginationSize={this.state.paginationSize}
          sortColumn={this.state.sortColumn}
          sortOrder={this.state.sortOrder}
          currentPage={1}
          errors={this.handlerError.bind(this)}
          refreshUsers={this.reloadUsers.bind(this)}
        />

        {this.renderPagination()}

        {this.state.errors.system ? (
          <Alert variant="danger">
            <Alert.Heading>No Data</Alert.Heading>
            <p>{this.state.errors.system}</p>

            <section className="users container">
              <div className="mt-2 mb-2">
                <a href="/users">back</a>
              </div>
            </section>
          </Alert>
        ) : null}

        <BulkHardDeleteModal
          show={this.state.bulkDelete.showModal}
          onClose={() => this.closeBulkDeleteModal()}
          onConfirm={() => this.handleBulkHardDelete()}
          isProcessing={this.state.bulkDelete.isDeleting}
          error={this.state.bulkDelete.error}
          users={this.state.bulkDelete.requests}
          isLoading={this.state.bulkDelete.isLoadingList}
          loadError={this.state.bulkDelete.listError}
        />
      </section>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    location: ownProps.location,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    post_app_user_list,
    dash_kpi,
    bulk_hard_delete_app_users,
  })(AppUsers),
);
